import { CheckCircle2, Clock, AlertTriangle } from "lucide-react";

const MAP = {
  regolare: { label: "Regolare", icon: CheckCircle2, cls: "bg-emerald-50 text-emerald-800 border-emerald-200", color: "green" },
  in_scadenza: { label: "In scadenza", icon: Clock, cls: "bg-amber-50 text-amber-800 border-amber-200", color: "yellow" },
  in_ritardo: { label: "In ritardo", icon: AlertTriangle, cls: "bg-rose-50 text-rose-800 border-rose-200", color: "red" },
};

export const StatusBadge = ({ status, testid }) => {
  const s = MAP[status];
  const Icon = s.icon;
  return (
    <span data-testid={testid} data-status={s.color} className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ${s.cls}`}>
      <Icon className="h-3.5 w-3.5" />{s.label}
    </span>
  );
};

const REPORT_MAP = {
  in_verifica: ["In verifica", "bg-amber-50 text-amber-800 border-amber-200"],
  approvata: ["Verificata", "bg-emerald-50 text-emerald-800 border-emerald-200"],
  respinta: ["Respinta", "bg-rose-50 text-rose-800 border-rose-200"],
};

export const ReportStatusBadge = ({ status, testid }) => {
  const [label, cls] = REPORT_MAP[status];
  return <span data-testid={testid} className={`inline-flex rounded-full border px-2.5 py-1 text-xs font-semibold ${cls}`}>{label}</span>;
};
